<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import OrderMedicineAPI from "../../../services/standards/ocupationalMedicine/orderMedicineAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Pagination from "@/components/standard/OcupationalMedicine/dangerPagination";
import Swal from "sweetalert2";
import EmployeeByIDAPI from "@/services/standards/ocupationalMedicine/employeeByIDAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.4 Evaluaciones médicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Pagination,
    CheckModal,
  },
  data() {

    return {
      title: "3.1.4 Evaluaciones médicas ocupacionales",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: 'Ordenes medicas',
        active: true,
      },
      ],

      
      company: "",

      itemData: null,
      userSelected: null,
      Datalist: [],
      lista: [],
      selectec: null,
      usersList: [],
      file: null,
      form_submitting: false,
      empleado: null,
      dataI: null,
      loading1: true,
      deleteCount: 0,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,

      ocupationalMedicine: {
        id: null,
        employee_id: null,
      },

      orderMedicine: {
        ocupational_medical_id: this.$route.params.id,
        note: null,
        file: null,
      },

      full_name: null,
      search: "",
      loading: true,
    };
  },
  methods: {

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(26)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },
    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getLastId() {
      OrderMedicineAPI.getAllOrder()
        .then((resp) => {
          if (resp.Ocupational_medical.data[0]['id']) {
            this.lastId = resp.Ocupational_medical.data[0]['id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/3.1.4/${this.$route.params.employee_id}/Recomendaciones/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.company.nit}/3.1.4/${this.$route.params.employee_id}/Recomendaciones/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.orderMedicine.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      OrderMedicineAPI.getOrderBy(this.$route.params.id)
        .then((response) => {
          this.lista = response.Ocupational_medical.data;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.form_submitting = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        OrderMedicineAPI.save(this.orderMedicine)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 26,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                window.location.reload();
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });

          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getUsersByID() {
      EmployeeByIDAPI.getId(this.$route.params.employee_id)
        .then((response) => {
          this.full_name = response.full_name
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteOrder(id) {
      OrderMedicineAPI.deleteOrder(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 26,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading1 = false
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getUsersByID();
    this.getList();
    this.getItemData();
    this.getLastId();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      A los colaboradores se les deberá informar de los resultados de las evaluaciones médicas
                      ocupacionales y se debe almacenar la evidencia de esta entrega.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 " id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>
              <hr>

              <div class="row mt-2">
                <h4 class="header-title col-6">
                  Seguimiento a empleado: {{ this.full_name }}
                </h4>
                <div class="col-6 text-right">

                </div>
              </div>
              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-12 px-2" label="¿Tiene recomendaciones?" label-for="note">
                    <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" type="date" id="tooltip7"
                      v-model="orderMedicine.note">
                    </b-form-textarea>
                    <b-tooltip target="tooltip7" placement="left">"Indicar si la evaluación médica tiene alguna
                      restricción o recomendación para el colaborador."</b-tooltip>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="!getRole('Crear') || !allowAccess() || this.form_submitting === true" type="submit"
                    class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <div class="form-row row text-center">
                            <form @submit.prevent="fetch()" class="form-inline">
                              <div class="col-sm-11 col-md-5">
                                <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                  class="form-control px-2" placeholder="Buscar"></b-form-input>
                              </div>
                              <div class="col-sm-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Recomendaciones</th>
                              <th class="text-center align-middle">Documento</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dato.note }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible
                                  </h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()"
                                    style=" background-color: transparent !important; border: none;" type="button"
                                    @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/medicina-ocupacional-danger-editar/${dato.id}` }">
                                      Editar</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Consultar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/${dato.id}/restricciones-colaboraciones-seguimientos/${dato.id}` }">
                                      Evidencia comunicación</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Consultar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/${dato.id}/restricciones-colaboraciones-seguimientos/${dato.id}` }">
                                      Restricciones y recomendaciones laborales</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteOrder(dato.id)">Eliminar</b-dropdown-item>

                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>

                        <div>
                          <Pagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
